import { render } from "./examStart.vue?vue&type=template&id=a5a460b0&scoped=true"
import script from "./examStart.vue?vue&type=script&lang=js"
export * from "./examStart.vue?vue&type=script&lang=js"

import "./examStart.vue?vue&type=style&index=0&id=a5a460b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a460b0"]])

export default __exports__